"use client"

import { Popover, PopoverPanel, Transition } from "@headlessui/react"
import { ArrowRightMini, XMark } from "@medusajs/icons"
import { Text, clx, useToggleState } from "@medusajs/ui"
import { Fragment } from "react"
import CatalogoMenu from './CatalogoMenu';
import { useState } from 'react';

// import { listCategoriesWithoutProducts, listCategories } from "@lib/data/categories";


import LocalizedClientLink from "@modules/common/components/localized-client-link"
import CountrySelect from "../country-select"
import { HttpTypes } from "@medusajs/types"

const SideMenuItems = {
  Home: "/",
  Store: "/store",
  "Envíos y Devoluciones": "/envios-devoluciones",
  Account: "/account",
  Cart: "/cart",
}

const SideMenu = ({ regions, product_categories }: { regions: HttpTypes.StoreRegion[] | null, product_categories: HttpTypes.StoreProductCategory[] }) => {

  // const product_categories = listCategoriesWithoutProducts();

  const [catalogo, setCatalogo] = useState(false)


  
  const toggleState = useToggleState()

  return (
    <div className="h-full">
      <div className="flex items-center h-full">
        <Popover className="h-full flex">
          {({ open, close }) => (
            <>
              <div className="relative flex h-full">
                <Popover.Button
                  data-testid="nav-menu-button"
                  className="relative h-full flex items-center transition-all ease-out duration-200 focus:outline-none hover:text-ui-fg-base"
                >
                  Menu
                </Popover.Button>
              </div>

              <Transition
                show={open}
                as={Fragment}
                enter="transition ease-out duration-150"
                enterFrom="opacity-0"
                enterTo="opacity-100 backdrop-blur-2xl"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 backdrop-blur-2xl"
                leaveTo="opacity-0"
              >
                <PopoverPanel className="flex flex-col absolute w-full pr-4 sm:pr-0 sm:w-1/3 2xl:w-1/4 sm:min-w-min h-[calc(100vh-1rem)] z-30 inset-x-0 text-sm text-ui-fg-on-color m-2 backdrop-blur-2xl">
                  <div
                    data-testid="nav-menu-popup"
                    className="flex flex-col h-full bg-[rgba(3,7,18,0.5)] rounded-rounded justify-between p-6"
                  >
                    <div className="flex justify-end" id="xmark">
                      <button data-testid="close-menu-button" onClick={close}>
                        <XMark />
                      </button>
                    </div>
                    {catalogo &&(
                      <CatalogoMenu product_categories={product_categories} onClose={() => { setCatalogo(false); close(); }}></CatalogoMenu>
                    )}
                    <ul className="flex flex-col gap-6 items-start justify-start">
                      {/* {Object.entries(SideMenuItems).map(([name, href]) => {
                        return (
                          <li key={name}>
                            <LocalizedClientLink
                              href={href}
                              className="text-3xl leading-10 hover:text-ui-fg-disabled"
                              onClick={close}
                              data-testid={`${name.toLowerCase()}-link`}
                            >
                              {name}
                            </LocalizedClientLink>
                          </li>
                        )
                      })} */}
                       <li key="home">
                       <LocalizedClientLink
                              href="/"
                              className="text-3xl leading-10 hover:text-ui-fg-disabled"
                              onClick={close}
                              data-testid={`inicio-link`}
                            >
                              Inicio
                            </LocalizedClientLink>
                          </li>
                          <li key="catalogo">
                            <button className="text-3xl leading-10 hover:text-ui-fg-disabled" onClick={()=>setCatalogo(!catalogo)}>Catálogo</button>
                          </li>
                          <li key="tienda">
                          <LocalizedClientLink
                              href="/store"
                              className="text-3xl leading-10 hover:text-ui-fg-disabled"
                              onClick={close}
                              data-testid={`tienda-link`}
                            >
                              Tienda 🏬
                            </LocalizedClientLink>
                          </li>
                          <li key="cuenta">
                            <LocalizedClientLink
                              href="/account"
                              className="text-3xl leading-10 hover:text-ui-fg-disabled"
                              onClick={close}
                              data-testid={`account-link`}
                            >
                              Tu cuenta 👤
                            </LocalizedClientLink>
                          </li>
                          <li key="carrito">
                            <LocalizedClientLink
                              href="/cart"
                              className="text-3xl leading-10 hover:text-ui-fg-disabled"
                              onClick={close}
                              data-testid={`cart-link`}
                            >
                              Ver carrito 🛒
                            </LocalizedClientLink>
                          </li>
                    </ul>
                    <div className="flex flex-col gap-y-6">
                      <div
                        className="flex justify-between"
                        onMouseEnter={toggleState.open}
                        onMouseLeave={toggleState.close}
                      >
                        {regions && (
                          <CountrySelect
                            toggleState={toggleState}
                            regions={regions}
                          />
                        )}
                        <ArrowRightMini
                          className={clx(
                            "transition-transform duration-150",
                            toggleState.state ? "-rotate-90" : ""
                          )}
                        />
                      </div>
                      <Text className="flex justify-between txt-compact-small">
                        © {new Date().getFullYear()} Farmacia Paseo 51. All rights
                        reserved.
                      </Text>
                    </div>
                  </div>
                </PopoverPanel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    </div>
  )
}

export default SideMenu
